import React from 'react';
import './AboutUsImageBlock.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function AboutUsImageBlock(data) {
  return (
    <div className={'container about-us-image-block'}>
      <div className={'wrapper'} data-aos="fade-up">
        {data.fields.images?.map((item) => {
          return (
            <div key={item.id} className={'imageWrapper'}>
              <div className={'item'}>
                <Image field={item.fields.image.fields.desktopImage} width={1392} height={640} />
                <div className={'item_content'}>
                  <h3 className={'item_content_title'}>{item.fields.title.value}</h3>
                  <p className={'item_content_text'}>{item.fields.text.value}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
